import React  from 'react'
import Layout  from './src/components/Layout'
import * as global  from './src/styles/global.css'

// Wraps every page in a component
export const wrapPageElement = ({ element, props }) => <Layout className={global} {...props}>{element}</Layout>
